import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Segment, Container } from 'semantic-ui-react';

import { Group, Policy, StoreList } from './limit';
import { Commons } from 'components';

const propTypes = {
};

const defaultProps = {
};

class LimitStore extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { sikdaeGroupClick, limitStoreSel, groupNum } = this.props;
    const style = {
      padding : "0"
      , border : "0"
    }

    return(
      <Grid padded columns='equal' className="limit-store">
        <Grid.Column style={style} className="box-left">
          <Group
            sikdaeGroupClick={sikdaeGroupClick}
            groupNum={groupNum}
          />
        </Grid.Column>
        <Grid.Column style={style} className="box-right">
          <Policy
            limitStoreSel={limitStoreSel}
            groupNum={groupNum}
          />
        </Grid.Column>
        <Grid.Column style={style} width={10}>
          <StoreList />
        </Grid.Column>
      </Grid>
    );
  }
}

LimitStore.propTypes = propTypes;
LimitStore.defaultProps = defaultProps;

LimitStore = connect(

  state => ({
    sikdaeGroup     : state.commons.sikdaeGroup
    , sikdaePolicy    : state.commons.sikdaePolicy
    , limitStoreResult  : state.sikdae.limitStoreResult
  })

)(LimitStore);

export default LimitStore;
